
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useStaffOwnedContactDeals = (staffId: string) => {
  return useQuery({
    queryKey: ["staff-owned-contact-deals", staffId],
    queryFn: async () => {
      console.log("Fetching deals from contacts owned by staff:", staffId);
      
      // First, get the contact IDs owned by this staff member
      const { data: contactIds, error: contactError } = await supabase
        .from('profiles')
        .select('id')
        .eq('internal_owner_id', staffId);
      
      if (contactError) {
        console.error("Error fetching contacts for staff:", contactError);
        throw contactError;
      }
      
      if (!contactIds || contactIds.length === 0) {
        console.log("No contacts found for staff:", staffId);
        return [];
      }
      
      const contactIdArray = contactIds.map(contact => contact.id);
      
      const { data, error } = await supabase
        .from('crm_deals')
        .select(`
          *,
          contact:crm_contacts(id, first_name, last_name, email),
          organization:organizations(id, name, company_id),
          stage:crm_deal_stages(id, name, color),
          assigned_staff:crm_staff(id, first_name, last_name, email),
          assigned_partner:crm_partners(id, first_name, last_name, email)
        `)
        .in('contact_id', contactIdArray)
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error("Error fetching staff owned contact deals:", error);
        throw error;
      }
      
      console.log("Fetched staff owned contact deals:", data);
      
      // Transform the data to ensure it matches the Deal interface
      const transformedData = (data || []).map(deal => ({
        ...deal,
        contact: Array.isArray(deal.contact) ? deal.contact[0] : deal.contact,
        organization: Array.isArray(deal.organization) ? deal.organization[0] : deal.organization,
        stage: Array.isArray(deal.stage) ? deal.stage[0] : deal.stage,
        assigned_staff: Array.isArray(deal.assigned_staff) ? deal.assigned_staff[0] : deal.assigned_staff,
        assigned_partner: Array.isArray(deal.assigned_partner) ? deal.assigned_partner[0] : deal.assigned_partner
      }));
      
      return transformedData;
    },
    enabled: !!staffId,
  });
};
